import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { debounce } from "lodash-es";
import {
  ref,
  computed,
  watch,
  nextTick,
  onMounted,
  onBeforeUnmount,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextTruncate',
  props: {
    str: {},
    fixed: { type: Boolean },
    right: { type: Boolean },
    animate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const container = ref<HTMLDivElement | null>(null);
const scroll = ref<HTMLDivElement | null>(null);
const shouldScroll = ref(false);
const animationTranslate = ref<string>();
const animationDuration = ref<string>();

let resizeObserver: ResizeObserver;

const nameComponent = computed(() => props.str);

const calculateTruncate = async () => {
  if (!props.animate) {
    return;
  }
  shouldScroll.value = false;
  await nextTick();
  if (!props.fixed && scroll.value && container.value?.clientWidth) {
    const { clientWidth } = container.value;
    const { clientWidth: scrollWidth } = scroll.value;
    const animationWidth = scrollWidth - clientWidth;
    const PADDING_WIDTH = 2;

    if (scrollWidth > clientWidth) {
      animationTranslate.value = `-${animationWidth + PADDING_WIDTH}px`;
      animationDuration.value = `${(animationWidth + PADDING_WIDTH) * 200}ms`;
      shouldScroll.value = true;
    }
  }
};

/**
 * Observe container size changes
 * in order to correctly truncate when container size changes
 */
const observeContainerSize = () => {
  resizeObserver = new ResizeObserver(
    debounce(() => {
      calculateTruncate();
    }, 100)
  );
  if (container.value) {
    resizeObserver.observe(container.value);
  }
};

watch(nameComponent, calculateTruncate);

onMounted(() => {
  if (!props.animate) {
    return;
  }
  observeContainerSize();
  // Sometimes setTimeout is needed for scroll to calculate proper width
  setTimeout(() => {
    calculateTruncate();
  }, 500);
});

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["truncate", { right: _ctx.right }])
  }, [
    _createElementVNode("span", {
      ref_key: "container",
      ref: container,
      class: _normalizeClass(["container", {
        fixed: _ctx.fixed,
        scrollable: shouldScroll.value,
      }]),
      style: _normalizeStyle({
        '--animationTranslate': animationTranslate.value,
        '--animationDuration': animationDuration.value,
      })
    }, [
      _createElementVNode("span", {
        ref_key: "scroll",
        ref: scroll,
        class: "inner"
      }, _toDisplayString(nameComponent.value), 513)
    ], 6)
  ], 2))
}
}

})